/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

export const normalizeOemMmyData = (data) => {
  if (!Array.isArray(data)) return [];

  const hasModelsArray = data.some((item) => Array.isArray(item?.models));
  if (hasModelsArray) {
    return data
      .map((item) => {
        const manufacturerName =
          item?.make || item?.manufacturerName || item?.name || "";
        const domain =
          item?.domain ||
          item?.domainAlias ||
          item?.domainName ||
          item?.domainAliasId ||
          "";
        const models = (item?.models || [])
          .map((model) => {
            const modelName =
              model?.name || model?.modelName || model?.model || "";
            let years;
            if (Array.isArray(model?.years)) {
              years = model.years;
            } else if (Array.isArray(model?.year)) {
              years = model.year;
            } else if (model?.year) {
              years = [model.year];
            } else {
              years = [];
            }
            return { modelName, years };
          })
          .filter((model) => model.modelName);

        return { manufacturerName, domain, models };
      })
      .filter((group) => group.manufacturerName);
  }

  const grouped = new Map();
  data.forEach((item) => {
    const make =
      item?.make || item?.manufacturerName || item?.manufacturer || item?.name;
    const modelName = item?.model || item?.modelName || item?.modelName;
    const year = item?.year || item?.modelYear;
    const domain = item?.domain || item?.domainAlias || item?.domainName || "";

    if (!make) return;

    if (!grouped.has(make)) {
      grouped.set(make, { manufacturerName: make, domain, models: [] });
    }

    if (!modelName) return;
    const entry = grouped.get(make);
    let modelEntry = entry.models.find((model) => model.modelName === modelName);
    if (!modelEntry) {
      modelEntry = { modelName, years: [] };
      entry.models.push(modelEntry);
    }

    if (year && !modelEntry.years.includes(year)) {
      modelEntry.years.push(year);
    }
  });

  return Array.from(grouped.values());
};
